var _ = require('lodash');
var appFontConfig;
var defaultAppSettings;
var defaultPropsConfig;
var persistenceConfig = require('./persistence-config');

require('swa-persistence/persistence').setConfig(persistenceConfig);
defaultPropsConfig = require('swa-app-configuration/default-props-config');
require('swa-app-base/spa-base-configuration');
require('swa-components-core/config/config').set(defaultPropsConfig);

var commonFontConfig = require('swa-app-configuration/common-font-config');
var configSettings = require('swa-app-config/settings');

configSettings.setLocationSPAPath('/corporate/landing/home-page/');

var Navigator = require('../navigator');
var servicesConfig = require('./services-config');

require('swa-app-core/initialize-session');
require('swa-search/search-store').instance('ResetStatus');
require('swa-service/services').setConfig(servicesConfig);
require('./placements-config');
require('./fixtures-config');
require('./data-extractor-config');
require('./service-status-handler-config');
require('./configureNextGenBootstrap');

var bootstrapSettings = require('swa-bootstrap-data/app-settings/corporate-landing-home-page-app-settings.corporate');

appFontConfig = _.merge({}, commonFontConfig, {
    webfonts: {
        enabled: true
    }
});
defaultAppSettings = _.assign({
    enableCarTrawler: true,
    geolocationEnabled: true,
    pageCallIncludesMetadata: true,
    retainProxyBookingInformation: false
}, appFontConfig);
configSettings.setAppSettings(bootstrapSettings, {
    default: defaultAppSettings,
    'corporate-landing-home-page-index': {
        contentHeight: 'full',
        contentWidth: 'full',
        customMaintenance: true,
        footerVersion: 'fullFooter',
        headerVersion: 'interiorPage',
        hidePageNotifications: true,
        insertH1Tag: true,
        Navigator: Navigator,
        pageCallIncludesMetadata: false
    },
    'corporate-landing-home-page-login': {
        corporateLoginRequired: false,
        footerVersion: 'fullFooter',
        hidePageNotifications: false
    }
});
